export const TOGGLE_STATES = {
    ON: 'on',
    OFF: 'off',
    IN_PROGRESS: 'in_progress',
};
export const LABEL_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right',
};
export const TOGGLE_SIZES = {
    BIG: 'big',
    SMALL: 'small',
};
